/* Context hand-off only. No cookies, trackers, cart changes or network requests. */
(() => {
  if (window.__ssSalesV3) return;
  window.__ssSalesV3 = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-ss-advice]');
    if (!link) return;
    try {
      const target = new URL(link.href, location.href);
      if (target.origin !== location.origin || !/^https?:$/.test(target.protocol)) return;
      const productUrl = new URL(link.dataset.ssProductUrl, location.origin);
      if (productUrl.origin !== location.origin) return;
      const section = link.closest('.shopify-section');
      const chosen = section?.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
        new URL(location.href).searchParams.get('variant');
      if (chosen && /^\d+$/.test(chosen)) productUrl.searchParams.set('variant', chosen);
      target.searchParams.set('ss_product', (link.dataset.ssProductTitle || '').slice(0,250));
      target.searchParams.set('ss_url', productUrl.pathname + productUrl.search);
      link.href = target.href;
    } catch (_) { /* Keep the valid original contact link. */ }
  });
  const prefill = () => {
    const path = location.pathname;
    if (!/\/pages\/(contact|kontakt)\/?$/.test(path)) return;
    const params = new URL(location.href).searchParams;
    const title = params.get('ss_product');
    const suppliedUrl = params.get('ss_url');
    if (!title || !suppliedUrl) return;
    const field = document.querySelector('form[action*="/contact"] textarea[name="contact[body]"]');
    if (!field || field.dataset.ssPrefilled || field.value.trim()) return;
    try {
      const safeUrl = new URL(suppliedUrl, location.origin);
      if (safeUrl.origin !== location.origin || !/\/products\//.test(safeUrl.pathname)) return;
      const english = document.documentElement.lang.toLowerCase().startsWith('en');
      const body = english ?
        `I would like advice about: ${title.slice(0,250)}\n${safeUrl.href}\n\nMy existing system / model:\n\nWhat I would like to achieve:\n` :
        `Jeg vil gerne have rådgivning om: ${title.slice(0,250)}\n${safeUrl.href}\n\nMit eksisterende system / model:\n\nDet vil jeg gerne opnå:\n`;
      field.value = body;
      field.dataset.ssPrefilled = 'true';
      field.dispatchEvent(new Event('input', { bubbles: true }));
    } catch (_) { /* Never insert an untrusted or malformed link. */ }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill, {once:true});
  else prefill();
  document.addEventListener('shopify:section:load', prefill);
})();
